module.exports = __webpack_public_path__ + "static/efficacy-5062bbae90f0835a7afab68375e07cde.svg";